import { Klass, csl, u_ } from "@pressmedia/webappbase";
import "@pressmedia/webappbase-plugin-popup";
import vuwer from "@pressmedia/vuwer";
import createModule from "./_createModule";
import "./klass/WallaceModule";

const { app } = window;
if( !(app instanceof Klass("WebAppBase") ) ) {
	throw new TypeError("The 'app' is not defined.");
}

app.storage.setPrefix( [
	`${app.name}${app._environment === "test" ? ".test" : ""}`,
	u_.pathInfo(app.URL).dirname.split("/").pop(),
	""
].join(".") );


/*******************
*    extend app    *
*******************/
Object.assign(app, {
	/*----------------
	* 動作に必要なパラメータ
	*/
	ttls: {
		pagettl: "管理システム",	// _config.jsonの値で置き換えられる
		subttls: {
			login: "ログイン",
			home: "メニュー",
			list: "一覧",
			edit: "入力フォーム",
			preview: "プレビュー"
		}
	},
	fm: {},
	moduleKlass: "WallaceModule",
	createModule,
	
	defaultViewOfApp: "home",
	defaultViewByContent: {
		_def_: "list"
	},
	
	/**
	 * ログインフォームの表示関数
	 * @returns Promise
	 */
	async showLoginForm() {
		let url = app.URL;
		
		if( !(/\/$/).test(url) ) {
			// /cms/articles -> /cms/
			url = url.slice(0, url.lastIndexOf("/") + 1);
		}
		
		app.setUrl(`${url}login`);
		return vuwer.setState({});
	},
	
	// ログイン待ちの状態用
	_waitingLogin: {},
	setWaitingLogin() {
		this._waitingLogin.URL = this.URL;
		csl.log.grey("waiting login...");
		return this;
	},
	
	setWaitingState(state) {
		u_.isObject(state) || (state = {});
		this._waitingLogin.state = state;
		return this;
	},
	
	clearWaitingLogin() {
		this._waitingLogin = {};
		return this;
	},
	
	isWaitingLogin() {
		return !!this._waitingLogin.URL;
	},
	
	/**
	 * ログイン待ち状態の解放
	 * @returns Promise
	 */
	async releaseWaitingLogin() {
		if( !this.isWaitingLogin() ) {
			const err = "app is not waiting login.";
			csl.warn("releaseWaitingLogin", err);
			return Promise.reject(err);
		}
		
		this.setUrl(this._waitingLogin.URL);
		await vuwer.setState( Object.assign({
			releaseWL: true
		}, this._waitingLogin.state || {}) );
		
		return this.clearWaitingLogin();
	},
	
	/*----------------
	* ログアウト
	* @return Promise
	*/
	async logout(isReject) {
		const method = "logout";
		const module = app.module || Klass.new_(this.moduleKlass, {
			app: this,
			config: this.config
		});
		
		delete this.config.account;
		
		this.showLoading("logout");
		
		await module._sendRequest(method, {
			url: `${module.apiBaseUrl}/auth`,
			type: "DELETE"
		}, err => {
			if(!err) {
				app.storage.del("nextToken");
				
				if( !isReject && u_.isFunction(app.alert) ) {
					return app.alert("ログアウトしました");
				}
			}
		}).catch(error => csl.warn("An error is catched.", { error }));
		
		this.hideLoading("logout");
		location.href = "./login";
		
		return this;
	},
	
	// [ログインコールバック]
	async onLoggedIn(res) {
		csl.log.blue("** login success **");
			
		if( app.isWaitingLogin() ) {
			// ※ログイン待ちの場合はログアウトボタンを有効にして終了
			this.nav.$btnLogout.removeClass("is-disable");
			return true;
		}
		
		// subttlsの編集
		Object.keys(res.config.menu).forEach(k => {
			const v = res.config.menu[k];
			if(u_.isString(v) && !res.config.dataItems[k]) {
				// dataItems以外のメニューがある場合はsubttlsへ追加する（カスタム用）
				this.ttls.subttls[k] = v;
			}
		});
		
		// コールバックを実行
		return !u_.isFunction(this.loginCallback) || this.loginCallback(res);
	},
	
	
	/**
	 * [override] execute
	 * @returns Promise
	 */
	async exec(...args) {
		const _super_ = Klass(this.klass).prototype.exec.bind(this);
		
		const { pagettl } = app.ttls;
		if(pagettl) {
			const titleSeparator = this.config.titleSeparator || " // ";
			document.title = [pagettl, document.title].join(titleSeparator);
		}
		
		return _super_(...args);
	},
	
	/**
	 * on execute
	 * @param {Object | null} err
	 * @param {Object} [res]
	 * @returns Promise
	 */
	async onExec(err, res) {
		// ポップアップ
		!!this.popup && this.popup.init(this);
		
		if(err) {
			if(u_.isObject(err) && err.type === "LOGIN") {
				csl.log.grey("Not logged in.");
			} else {
				return false;
			}
		}
		
		// create app.module
		this.module = this.createModule();
		
		// 部品自動生成前のコールバックを実行
		if( !err && u_.isFunction(this.execCallback) ) {
			await this.execCallback(res);
		}
		
		// コンポーネントの準備
		await vuwer.getReady();
		
		csl.log.blue("** vuwer is ready. **");
		const methods = [];
		
		// ログイン中であればコールバックを実行
		if( this.config.account && u_.isFunction(this.onLoggedIn) ) {
			methods.push( this.onLoggedIn(res) );
		}
		
		await Promise.all(methods);
		
		if( u_.isFunction(this.initFooterCallback) ) {
			const siteFooter = vuwer.get("siteFooter");
			await this.initFooterCallback.call(siteFooter, siteFooter.$self);
		}
		
		if(app.config.account) {
			const reg = new RegExp(`(${RegExp.escape(app.defaultViewOfApp)}|login)$`);
			reg.test(app.URL) && app.setUrl( app.URL.replace(reg, "") );
			
			const startState = { ...app._GET };
			u_.hasProperty(startState, "sheet") && (delete startState.sheet);
			
			// 初期状態をvuwerへ反映
			return vuwer.setState(startState);
			
		} else {
			// 未認証の場合はログインフォームを表示
			return app.showLoginForm();
		}
	},
	
	/**
	 * after execute
	 * @returns Promise
	 */
	async afterExec() {
		if(vuwer.isReady) {
			// CMS部分の描画時間を考慮して、処理を遅らせる
			return new Promise(resolve => setTimeout(() => {
				// フッタを最下部にフィックス
				vuwer.fixBottom("appFooter");
				vuwer.$window.trigger("resize", [true]).trigger("scroll", [true]);
				csl.log.blue("**** app is ready. ****");
				resolve();
			}, 100));
			
		} else {
			return Promise.reject();
		}
	},
	
	
	/*********************
	* set util functions *
	*********************/
	// [ajaxエラー時に実行される関数の再定義]
	ajaxErrorCallback(...args) {
		const _super_ = Klass(this.klass).prototype.ajaxErrorCallback.bind(this);
		const msg = _super_(...args);
		
		// 非同期で処理を行う
		new Promise(resolve => {
			if(!msg) {
				resolve(true);
				return false;
			}
			
			if(this._environment === "prod") {
				if( u_.isFunction(this.alert) ) {
					this.alert(msg, () => resolve(true));
				} else {
					const message = u_.replaceHtmlTag(
						msg.replace(/<br\/?>/g, "\n")
					);
					alert(message);
					resolve(true);
				}
				return false;
			}
			
			const cMsg = `${msg}<br><br>ログイン画面に遷移しますか？`;
			if( u_.isFunction(this.confirm) ) {
				this.confirm(cMsg, () => resolve(true), () => resolve(false));
			} else {
				const message = u_.replaceHtmlTag(
					cMsg.replace(/<br\/?>/g, "\n")
				);
				resolve( confirm(message) );
			}
		})
		.catch(error => csl.warn("An error is catched.", { error }))
		.then(goReload => goReload && (location.href = "./"));
		
		return msg;
	}
});
